<template>
  <div>
    <div class="signIn-box text-center forgot-container">
      <img class="logo mb-30" v-if="studyConfig" :src="studyConfig.studyLogoUrl" />
      <p class="SignIn-title mb-30" v-translate:SIGN_IN_TITLE="lang">Sign In</p>
      <div class="form-group">
        <input
          type="email"
          v-validate="'required|email'"
          name="email"
          :class="{
            input: true,
            'is-danger': errors.has('email'),
            'is-success': !errors.has('email')
          }"
          class="form-control form-control-lg"
          v-model="userCredentials.email"
          v-translate:EMAIL_PLACEHOLDER.placeholder="lang"
          placeholder="Email"
          @keyup.enter="loginUser"
          required
        />
        <span v-show="errors.has('email')" class="error-style" v-translate:error_email="lang"></span>
      </div>
      <div class="form-group mb-0">
        <input type="password" name="password" class="form-control form-control-lg" v-model="userCredentials.password" v-translate:PASSWORD_PLACEHOLDER.placeholder="lang" placeholder="Password" autocomplete="off" @keyup.enter="loginUser" required />
      </div>
      <div class="form-group mb-0">
        <button type="submit" class="btn signIn-btn primary-bg" :class="{ rwebsignin: isFromRweb() }" :disabled="isDisabled" v-on:click.prevent="loginUser" v-translate:sing_in="lang">Sign In</button>
      </div>
      <div class="d-flex justify-content-between pt-27 forgot-link">
        <a class="cursor-pointer" @click="activeState('password')" :class="{ 'mx-auto': !pwebCognitoAuthentication }" v-translate:FORGOT_PASSWORD_TITLE="lang">Forgot Password</a>
      </div>
      <div class="justify-content-between pt-27 signin-with-phone text-center cursor_pointer" v-if="!pwebCognitoAuthentication && portal.getVerificationMethod() != 'email'">
        <p @click="$emit('onChangeSigninMethod', true)" v-translate:lable_sign_in_with_phone="lang">Sign In with Verification Phone</p>
      </div>
    </div>
    <div class="confirmEmailModel">
      <div class="modal fade" id="beforeLogin" tabindex="-1" role="dialog" aria-labelledby="clear_all_notify" aria-hidden="true">
        <div class="modal-dialog " role="document">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <div class="verification text-center mt-15 pt-17 p-2">
                <label class="email-id">{{ errorMessage }}</label>
              </div>
              <div class="row leave_study_btn_grp">
                <div class="col-6 col-md-6">
                  <button data-dismiss="modal" class="btn leavestudy" v-translate:CANCEL_BUTTON_TITLE="lang">Cancel</button>
                </div>
                <div class="col-6 col-md-6">
                  <button class="btn leave_study_cntue primary-bg" data-toggle="modal" data-target="#YesleaveStudyModal" v-on:click.prevent="permitAlreadyLogin" data-dismiss="modal" v-translate:YES_TEXT="lang">Yes</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Widget, ParticipantPortal } from "@/components/services/participant-service";
import localStorageService from "@/services/localStorage";
import nprogress from "nprogress";
import $ from "jquery";

export default {
  name: "login-legacy",
  components: {},
  props: ["studyId", "userCredentials", "isStudySelected"],
  data() {
    return {
      loading: false,
      errorMessage: "",
      selectedStudyId: null,
      isLoginSuccess: false,
      isUserAlreadyLoggedIn: false,
      widget: new Widget(),
      portal: new ParticipantPortal(),
      studyConfig: null
    };
  },
  mounted() {
    this.portal.isFromWeb();
    this.selectedStudyId = this.studyId;
    //TUR-61129
    this.$root.$emit("setHeaderOptions", null);
    //TUR-61129
  },
  computed: {
    ...mapGetters(["participant", "token", "pwebCognitoAuthentication", "getParticipantsPortalGlobalElements"]),
    isDisabled() {
      return !this.userCredentials.email || !this.userCredentials.password;
    },
    lang() {
      let selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    }
  },
  watch: {
    getParticipantsPortalGlobalElements(val) {
      this.studyConfig = val;
    },
    studyId(val) {
      this.selectedStudyId = val;
    }
  },
  methods: {
    ...mapActions(["awsCognitoLogin", "participantLogin", "participantLogout", "participantLoadProfile"]),
    async loginUser() {
      if (!this.errors.any()) {
        this.formErrors = false;
        try {
          nprogress.start();
          this.userCredentials.email = this.userCredentials.email.toLowerCase();
          let postData = Object.assign({}, this.userCredentials);
          postData.language = localStorageService.getItem("pw-languageId");
          postData.country = localStorageService.getItem("pw-countryId");
          postData.studyId = this.selectedStudyId ? this.selectedStudyId : "";
          postData.isUserAlreadyLoggedIn = this.isUserAlreadyLoggedIn;
          localStorageService.setItem("pw-deviceId", postData.deviceId);
          await this.participantLogin(postData);
        } catch (error) {
          nprogress.done();
          let message = "";
          switch (error.message) {
            case "ANOTHER_PARTICIPANT_LOGIN_ACTIVE":
              message = this.widget.translate(error.message, "Another active login has been detected for this account. Would you like to sign out of all other sessions?");
              break;
            case "PASSWORD_ENTERED_IS_INCORRECT":
              message = this.widget.translate(error.message, "Password entered is incorrect");
              break;
            case "UNABLE_TO_VERIFY_EMAIL_PASSWORD":
              message = this.widget.translate(error.message, "Unable to verify email and/or password.");
              break;
            case "UNABLE_TO_LOGIN_PARTICIPANT_WITHDRAWN":
              message = this.widget.translate(error.message, "Your account has been deactivated. If you have any questions, please contact your study team.");
              break;
            case "PARTICIPANT_CONFIGURED_LANGUAGE_ERROR":
              message = this.widget.translate(error.message, "The language does not match your original selection. If you wish to change the language you are using for this study, please contact your study team.");
              break;
            case "PARTICIPANT_CONFIGURED_COUNTRY_ERROR":
              message = this.widget.translate(error.message, "The selected country doesn't match the country selected during enrollment. Please select the country you originally enrolled with.");
              break;
            case "USER_CREDENTIALS_NOT_FOUND":
              message = this.widget.translate(error.message, "Unable to verify email and/or password.");
              break;
            case "PARTICIPANT_UNABLE_TO_LOGIN":
              message = this.widget.translate(error.message, "Unable to login, please try after some time.");
              break;
            case "email_verification_reconfirm_message":
              message = this.widget.translate(error.message, "Unable to login, please try after some time.");
              break;
            case "EMAIL_INCORRECT_FOUND":
              message = this.widget.translate("UNABLE_TO_VERIFY_EMAIL_PASSWORD", "Unable to verify email and/or password.");
              break;
          }
          if (error.message == "ANOTHER_PARTICIPANT_LOGIN_ACTIVE") {
            this.isUserAlreadyLoggedIn = true;
            this.errorMessage = message;
            $("#beforeLogin").modal("toggle");
          } else {
            message ? this.$toastr.error(message) : this.$toastr.error(error.message);
          }
        }
      }
    },
    activeState(state) {
      switch (state) {
        case "username":
          this.$router.push({ name: "participants-portal-auth-forgot-username" });
          break;
        case "password":
          this.$router.push({ name: "participants-portal-auth-forgot-password" });
          break;
      }
    },
    async permitAlreadyLogin() {
      this.userCredentials.isUserAlreadyLoggedIn = true;
      await this.loginUser();
    },
    isFromRweb() {
      return !!this.portal.getStudy();
    }
  }
};
</script>

<style scoped>
/* .forgot-container, .loading {
margin-top: calc(50vh - 270px) !important;
} */
.signin-with-phone {
  color: #c4c4c4;
  font-size: 16px;
  font-weight: 500;
}
</style>
